var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5375 4.1376C3.13759 3.53769 3.95138 3.20068 4.7999 3.20068C5.64843 3.20068 6.46221 3.53769 7.0623 4.1376L7.9999 5.0744L8.9375 4.1376C9.23269 3.83196 9.58579 3.58818 9.97621 3.42047C10.3666 3.25276 10.7865 3.16449 11.2114 3.1608C11.6363 3.1571 12.0577 3.23807 12.451 3.39897C12.8442 3.55987 13.2015 3.79748 13.502 4.09793C13.8024 4.39839 14.04 4.75568 14.2009 5.14894C14.3618 5.54221 14.4428 5.96359 14.4391 6.38848C14.4354 6.81337 14.3471 7.23328 14.1794 7.62369C14.0117 8.0141 13.7679 8.36721 13.4623 8.6624L7.9999 14.1256L2.5375 8.6624C1.9376 8.06231 1.60059 7.24852 1.60059 6.4C1.60059 5.55147 1.9376 4.73769 2.5375 4.1376Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.0fedd49da6294a325551bf80df6a9d68.svg";
export { ForwardRef as ReactComponent };